export const initialDataState = {
  sort: [
    {
      field: "code",
      dir: "asc",
    },
  ],
};

export const SERVICE_POINT_INFORMATION = {
  customerId: "",
  cashCenterId: "",
  locationId: "",
  locationName: "",
  locationCode: "",
  category: "",
  routeNo: "",
  locationType: "",
  status: "",
  siteType: "",
  fixingSide: "",
  loadingSide: "",
  machineType: "",
  maker: "",
  model: "",
  lockSerialNo: "",
  machineSerialNo: "",
  barcode: "",
  siteLimit: "",
  distanceFromBase: 0,
  coLocatedGroupNo: 0,
  maximumCassettes: 0,
  requiresCashierCount: true,
  requiresEVhr: true,
  hasSecurityAlarm: false,
  alarmDetails: "",
  country: "",
  state: "",
  emirate: "",
  city: "",
  address: "",
  longitude: 0,
  latitude: 0,
  lockInstallationDate: null,
  firstServiceDate: null,
  decomissionedDate: null,
  followStandardModels: true,
  followStandardDenominations: true,
  followStandardCassettes: true,
  dedicatedSerials: [],
  serviceDays: [],
  allowedDays: [],
  siteSLAs: [],
  operationalWindows: [],
  serviceWindows: [],
  cassettes: [],
  denominations: [],
  replenishmentModels: [],
  siteRepresentatives: [],
};

export const LOCATION_TYPES = [
  {
    id: "Branch",
    text: "Branch",
  },
  {
    id: "VIP",
    text: "VIP",
  },
  {
    id: "Hub",
    text: "Hub",
  },
  {
    id: "ATM",
    text: "ATM",
  },
  {
    id: "CDM",
    text: "CDM",
  },
  {
    id: "Combo",
    text: "Combo",
  },
  {
    id: "ITM",
    text: "ITM",
  },
  {
    id: "Recycler",
    text: "Recycler",
  },
  {
    id: "KIOSK",
    text: "KIOSK",
  },
  {
    id: "SCDM",
    text: "SCDM",
  },
];

export const STATUS_LIST = [
  { id: "Active", text: "Active" },
  { id: "Decommissioned", text: "Decommissioned" },
];

export const CATEGORY_LIST = [
  { id: "A", text: "A" },
  { id: "B", text: "B" },
  { id: "C", text: "C" },
];

export const SITE_TYPE_LIST = [
  {
    id: "CIT",
    text: "CIT",
  },
  {
    id: "Machine",
    text: "Machine",
  },
];

export const FIXING_SIDE = [
  {
    id: "Drive Up Island",
    text: "Drive Up Island",
  },
  {
    id: "Lobby Room Window",
    text: "Lobby Room Window",
  },
  {
    id: "Drive Up Kiosk",
    text: "Drive Up Kiosk",
  },
  {
    id: "Lobby Stand Alone",
    text: "Lobby Stand Alone",
  },
];

export const LOADING_SIDE_LIST = [
  { id: "Front", text: "Front" },
  { id: "Rear", text: "Rear" },
];
export const WEEK_DAYS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export const siteSLADefault = {
  region: "",
  serviceType: "",
  activityType: "",
  responseTime: "0",
  attendedTime: "0",
  resolutionTime: "0",
};
export const OPERATION_WINDOW_DEFAULT = {
  startDateTime: new Date(),
  endDateTime: new Date(),
  cutOffTime: new Date(),
};
export const SERVICE_WINDOW_DEFAULT = {
  startDateTime: new Date(),
  endDateTime: new Date(),
  cutOffTime: new Date(),
};
export const denominationDefault = {
  currency: null,
  multiple: null,
  noOfCassettes: "0",
  noOfNotes: "0",
};

export const replenishmentModelsDefault = {
  code: "",
  ...denominationDefault,
  denominations: [],
  models: [],
};

export const CASSETTES_DEFAULT = {
  description: "",
  currency: "",
  multiple: "",
  cassetteType: "",
  maker: "",
  limit: 0,
  dualScanning: true,
};

export const DENOMINATIONS_DEFAULT = {
  currency: "",
  multiple: "",
  shape: "",
  version: "",
};

export const CASSETTES_TYPE = [
  {
    id: "Type 1",
    text: "Type 1",
  },
  {
    id: "Type 2",
    text: "Type 2",
  },
  {
    id: "Type 3",
    text: "Type 3",
  },
  {
    id: "Type 4",
    text: "Type 4",
  },
  {
    id: "Type 5",
    text: "Type 5",
  },
  {
    id: "Type 6",
    text: "Type 6",
  },
  {
    id: "Cash Bin",
    text: "Cash Bin",
  },
  {
    id: "Reject Bin",
    text: "Reject Bin",
  },
];
export const CASSETTES_DESCRIPTIONS = [
  {
    id: "ATM Cassette",
    text: "ATM Cassette",
  },
  {
    id: "CDM Cassette",
    text: "CDM Cassette",
  },
  {
    id: "ATM Reject Bin",
    text: "ATM Reject Bin",
  },
  {
    id: "CDM Cash Bin",
    text: "CDM Cash Bin",
  },
];

export const _DEFAULT_SITE_REPRESENTATIVE = {
  name: "",
  employeeId: "",
  mobileNo: "",
  email: "",
};
